export const prevArrow = `<span class="slick-arrow slick-prev"><span class="icon-holder theme--cta"><svg xmlns="http://www.w3.org/2000/svg" width="6.101" height="9.373" viewBox="0 0 6.101 9.373"><path id="Path_196" data-name="Path 196" d="M0,0,3.98,3.979,7.959,0" transform="translate(0.707 8.666) rotate(-90)" fill="none" stroke="currentColor" stroke-width="2"/></svg></span></span>`;
export const nextArrow = `<span class="slick-arrow slick-next"><span class="icon-holder theme--cta"><svg xmlns="http://www.w3.org/2000/svg" width="6.101" height="9.373" viewBox="0 0 6.101 9.373"><path id="Path_196" data-name="Path 196" d="M0,0,3.98,3.979,7.959,0" transform="translate(0.707 8.666) rotate(-90)" fill="none" stroke="currentColor" stroke-width="2"/></svg></span></span>`;

export const defaultOptions = {
    // autoplay: true,
    // autoplaySpeed: 4000,
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: false,
    cssEase: "ease",
    speed: 600,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
};

export const prevArrowCustom = (slider) => {
    return slider
        .closest("[data-slider-block]")
        .find("[data-slider-arrows]")
        .find(".slick-prev");
};

export const nextArrowCustom = (slider) => {
    return slider
        .closest("[data-slider-block]")
        .find("[data-slider-arrows]")
        .find(".slick-next");
};
